module.exports = __webpack_public_path__ + "img/winwheel-pointer.41179a74.png";